import { createContext, useContext } from "react"

// "default" is the horizontal pill strip; "sidebar" renders the same tab
// machinery as a left nav column (icons, right-aligned counts) for pages
// whose tabs are really sub-pages.
export type TabsVariant = "default" | "sidebar"

type TabsStateContext = {
  isLoading: boolean
  error: Error | null | undefined
  isEmpty: boolean
  emptyLabel: string
  variant: TabsVariant
}

export const TabsStateContext = createContext<TabsStateContext | undefined>(
  undefined,
)

export function useTabsState() {
  return useContext(TabsStateContext)
}
